import { Component, inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ClientConfigService } from '../../../../services/client-config.service';
import { NgClass } from '@angular/common';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    imports: [NgClass, MatDivider]
})
export class FooterComponent {
  private clientConfigService = inject(ClientConfigService);

  chillPortalAddress: string = environment.chill.portalAddress;
  brokerId: string = this.clientConfigService.getBrokerId();
}
